export default "__VITE_ASSET__BnJJVsRU__"